import React from 'react'
import './card-featured-article.scss'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { encryptUserInfo } from '../../../shared/utils/encryptUserInfo'
import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil'

const CardFeaturedArticle = ({ image, title, redirection }) => {

  const dataLayerArticles = (title) => {
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: 'Interacciones_Articulos_VConfident',
      category: 'v-confident',
      action: 'click',
      label: title,
      sub_category: 'academia',
      article_name: title,
      article_type: 'texto',
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  return (
    <a
      className="f-card-featured-article"
      onClick={e => {
        e.preventDefault()
        dataLayerArticles(title)
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'ga_event',
          category: 'V-Confident :: Home',
          action: 'Click :: Artículos',
          label: title,
          value: '',
        })

        window.location.href = redirection
      }}
      href={redirection}
    >
      <div className="f-card-featured-article__image">
        <GatsbyImage
          image={getImage(image)}
          alt={image.description}
          className="f-card-featured-article__image-img"
        />
      </div>
      <p className="f-card-featured-article__txt">{title}</p>
    </a>
  )
}

export default CardFeaturedArticle
